import { BlockEditProps } from "@wordpress/blocks";
import React, { useState } from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
  URLInput,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  ToggleControl,
  PanelBody,
  PanelRow,
  TextControl,
  CheckboxControl,
} from "@wordpress/components";

export default function ButtonEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "button" });
  const [isChecked, setChecked] = useState(true);
  return (
    <>
      <InspectorControls>
        <PanelBody>
          <PanelRow>
            <TextControl
              label="Button Url"
              value={props.attributes.linkUrl ?? ""}
              onChange={(newlinkUrl) =>
                props.setAttributes({ linkUrl: newlinkUrl })
              }
            />
          </PanelRow>
          <PanelRow>
            <CheckboxControl
              label="Im neuen Tab öffnen"
              checked={props.attributes.openInNewTab ?? false}
              onChange={(newValue) =>
                props.setAttributes({ openInNewTab: newValue })
              }
            />
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      <div className="button-wrapper">
        <a {...blockProps}>
          <RichText
            value={props.attributes.text ?? ""}
            onChange={(newText) => props.setAttributes({ text: newText })}
            placeholder="Text"
          />
        </a>
      </div>
    </>
  );
}
